import { render, staticRenderFns } from "./userDetailPage.vue?vue&type=template&id=d048a6a6&scoped=true&"
import script from "./userDetailPage.vue?vue&type=script&lang=js&"
export * from "./userDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./userDetailPage.vue?vue&type=style&index=0&id=d048a6a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d048a6a6",
  null
  
)

export default component.exports